import { inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

export function translateTitle(title: string) {
  const transloco = inject(TranslocoService);
  return transloco.selectTranslate(title);
}
